module.exports = __webpack_public_path__ + "fonts/araboto-black-webfont.1b3acaed.woff";